export const REFRESH_TOKEN_ERROR = 'RefreshAccessTokenError'
